import LayoutRepository from './layoutRepository'
import OrdersRepository from './ordersRepository'
import ProductsRepository from './productsRepository'
import ReferencesRepository from './referencesRepository'
import UsersRepository from './usersRepository'

const repositories = {
  layout: LayoutRepository,
  orders: OrdersRepository,
  products: ProductsRepository,
  references: ReferencesRepository,
  users: UsersRepository,
}

export const RepositoryFactory = {
  get: name => repositories[name]
}